import { useState } from 'react';
import dayjs, { type Dayjs } from 'dayjs';
import { Alert, Box, Button, Paper, Stack, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {
  ReservationStatsSection,
  defaultStatsRange,
  type StatsRange,
} from '../../../pages/dashboard/ReservationStatsSection';

const MAX_RANGE_DAYS = 365;

/**
 * Dedicated "Rezervasyon İstatistikleri" screen (legacy `ReservationStats/Index`).
 * Reuses the exact hand-rolled MUI widgets from the Anasayfa dashboard section
 * (`ReservationStatsSection`), adding a date-range picker on top. `GetReservationStats`
 * rejects ranges over 365 days, so the Uygula button is disabled past that.
 */
export default function ReservationStatsPage() {
  const initial = defaultStatsRange();
  const [start, setStart] = useState<Dayjs | null>(dayjs(initial.startDate));
  const [end, setEnd] = useState<Dayjs | null>(dayjs(initial.endDate));
  const [applied, setApplied] = useState<StatsRange>(initial);

  const rangeDays = start && end ? end.diff(start, 'day') : 0;
  const invalid = !start || !end || !start.isValid() || !end.isValid() || rangeDays < 0;
  const tooWide = rangeDays > MAX_RANGE_DAYS;

  const apply = () => {
    if (invalid || tooWide || !start || !end) return;
    setApplied({ startDate: start.format('YYYY-MM-DD'), endDate: end.format('YYYY-MM-DD') });
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Rezervasyon İstatistikleri
      </Typography>

      <Paper sx={{ p: 2, mb: 1 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ alignItems: { sm: 'center' } }}>
          <DatePicker
            label="Başlangıç"
            value={start}
            onChange={setStart}
            slotProps={{ textField: { size: 'small' } }}
          />
          <DatePicker
            label="Bitiş"
            value={end}
            onChange={setEnd}
            slotProps={{ textField: { size: 'small' } }}
          />
          <Button variant="contained" onClick={apply} disabled={invalid || tooWide}>
            Uygula
          </Button>
        </Stack>
        {tooWide && (
          <Alert severity="warning" sx={{ mt: 1.5 }}>
            Tarih aralığı en fazla 365 gün olabilir.
          </Alert>
        )}
      </Paper>

      <ReservationStatsSection
        range={applied}
        title={`İstatistikler (${dayjs(applied.startDate).format('DD.MM.YYYY')} – ${dayjs(applied.endDate).format('DD.MM.YYYY')})`}
      />
    </Box>
  );
}
